import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, withRouter, Switch } from 'react-router-dom';
import firebase from 'firebase';

import Main from './Components/Main/Main';

import Login from './Components/Auth/Login';

const PrivateRoute = ({ component: Component, isAuth, ...rest }) => {
	return (
		// Show the component only when the user is logged in
		// Otherwise, redirect the user to /signin page
		<Route {...rest} render={(props) => (isAuth ? <Component {...props} /> : <Redirect to="/login" />)} />
	);
};

class App extends Component {
	constructor() {
		super();

		const firebaseConfig = {
			apiKey: 'AIzaSyCD685BTFJStJMZIFidlxtuCL7BQVjj_wk',
			authDomain: 'lascasas-3d1df.firebaseapp.com',
			databaseURL: 'https://lascasas-3d1df.firebaseio.com',
			projectId: 'lascasas-3d1df',
			storageBucket: 'lascasas-3d1df.appspot.com',
			messagingSenderId: '426950839125',
			appId: '1:426950839125:web:aa1644122311f63ba93ddc',
			measurementId: 'G-1TN6XWSD8X'
		};
		// Initialize Firebase
		firebase.initializeApp(firebaseConfig);

		this.state = {
			isAuth: false,
			redirect: false
		};
	}

	loginUser = (email, password) => {
		console.log('_clicked login');

		firebase.auth().signInWithEmailAndPassword(email, password).catch((error) => {
			console.log('error', error);
		});
	};

	componentDidMount() {
		firebase.auth().onAuthStateChanged((user) => {
			if (user) {
				this.setState({ isAuth: true });
			} else {
				this.setState({ isAuth: false });
			}
		});
	}

	render() {
		return (
			<Router>
				<Route
					path="/login"
					render={(props) => <Login isAuth={this.state.isAuth} loginUser={this.loginUser} />}
				/>
				<PrivateRoute path="/" component={Main} isAuth={this.state.isAuth} />
			</Router>
		);
	}
}

export default App;
